import {data} from "jquery";
import {useGetCatgeory, useGetSectors} from "../../../hooks/useCategory";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoImage from "../../../images/NoImage.jpg";
import {Children} from "react";

const SelectSector = ({selectedSector, setSelectedSector, children}) => {
  const {data: sectors, isLoading: isLoadingSector} = useGetSectors();
  return (
    <section>
      <h4 className="font-bold text-[18px] text-[#19295C] ">
        Indiquez le secteur
      </h4>
      <div className="flex flex-col w-full !px-10 !py-3 gap-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 w-full gap-3">
          {!!sectors?.length &&
            sectors?.map((sector) => (
              <div className="w-full" key={sector.id}>
                <div
                  className={`border-2 rounded-xl border-solid flex flex-col justify-start items-center gap-5 !pt-3 !pb-2 !px-5 cursor-pointer relative h-full ${
                    sector?.id === selectedSector?.id &&
                    "bg-[#EEF6FF] border-[#1A64B9]"
                  }`}
                  onClick={() => {
                    setSelectedSector(sector);
                  }}
                >
                  {sector?.id === selectedSector?.id && (
                    <div className="absolute top-2 right-2 text-[#1A64b9] text-lg flex justify-center items-center rounded-full">
                      <i className="fi fi-ss-check-circle"></i>
                    </div>
                  )}
                  <ImageComponent
                    alt={"icon"}
                    src={buildImageUrl(sector.imagePath)}
                    className={"h-14 w-auto object-contain"}
                    fallback={
                      <img alt="icon" src={NoImage} className={"h-14 w-auto"} />
                    }
                  />
                  <div
                    className={"font-bold text-sm text-center text-[#19295C]"}
                  >
                    {sector.title}
                  </div>
                </div>
              </div>
            ))}
        </div>
        {children}
      </div>
    </section>
  );
};
export default SelectSector;
